/* tslint:disable */
/* eslint-disable */
/**
 * chinaone-java
 * No description provided (generated by Openapi Generator https://github.com/openapitools/openapi-generator)
 *
 * The version of the OpenAPI document: 1.0.0
 * 
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */

import { mapValues } from '../runtime';
/**
 * 
 * @export
 * @interface StockGoodsListSkuProductItem
 */
export interface StockGoodsListSkuProductItem {
    /**
     * SKU商品组成ID
     * @type {number}
     * @memberof StockGoodsListSkuProductItem
     */
    id?: number;
    /**
     * 商品图片URL
     * @type {string}
     * @memberof StockGoodsListSkuProductItem
     */
    imageUrl?: string;
    /**
     * 商品链接
     * @type {string}
     * @memberof StockGoodsListSkuProductItem
     */
    productUrl?: string;
    /**
     * 商品链接（下单用，与 productUrl 一致）
     * @type {string}
     * @memberof StockGoodsListSkuProductItem
     */
    url?: string;
    /**
     * 单价(¥)
     * @type {number}
     * @memberof StockGoodsListSkuProductItem
     */
    unitPrice?: number;
    /**
     * 颜色
     * @type {string}
     * @memberof StockGoodsListSkuProductItem
     */
    color?: string;
    /**
     * 尺寸
     * @type {string}
     * @memberof StockGoodsListSkuProductItem
     */
    size?: string;
    /**
     * 构成数量
     * @type {number}
     * @memberof StockGoodsListSkuProductItem
     */
    productNumber?: number;
    /**
     * 通关类目ID
     * @type {number}
     * @memberof StockGoodsListSkuProductItem
     */
    ctmsItemId?: number;
    /**
     * 商品来源：1-URL，2-SKU，3-库存，4-购物车
     * @type {number}
     * @memberof StockGoodsListSkuProductItem
     */
    sourceType?: number;
}

/**
 * Check if a given object implements the StockGoodsListSkuProductItem interface.
 */
export function instanceOfStockGoodsListSkuProductItem(value: object): value is StockGoodsListSkuProductItem {
    return true;
}

export function StockGoodsListSkuProductItemFromJSON(json: any): StockGoodsListSkuProductItem {
    return StockGoodsListSkuProductItemFromJSONTyped(json, false);
}

export function StockGoodsListSkuProductItemFromJSONTyped(json: any, ignoreDiscriminator: boolean): StockGoodsListSkuProductItem {
    if (json == null) {
        return json;
    }
    return {
        
        'id': json['id'] == null ? undefined : json['id'],
        'imageUrl': json['imageUrl'] == null ? undefined : json['imageUrl'],
        'productUrl': json['productUrl'] == null ? undefined : json['productUrl'],
        'url': json['url'] == null ? undefined : json['url'],
        'unitPrice': json['unitPrice'] == null ? undefined : json['unitPrice'],
        'color': json['color'] == null ? undefined : json['color'],
        'size': json['size'] == null ? undefined : json['size'],
        'productNumber': json['productNumber'] == null ? undefined : json['productNumber'],
        'ctmsItemId': json['ctmsItemId'] == null ? undefined : json['ctmsItemId'],
        'sourceType': json['sourceType'] == null ? undefined : json['sourceType'],
    };
}

export function StockGoodsListSkuProductItemToJSON(json: any): StockGoodsListSkuProductItem {
    return StockGoodsListSkuProductItemToJSONTyped(json, false);
}

export function StockGoodsListSkuProductItemToJSONTyped(value?: StockGoodsListSkuProductItem | null, ignoreDiscriminator: boolean = false): any {
    if (value == null) {
        return value;
    }

    return {
        
        'id': value['id'],
        'imageUrl': value['imageUrl'],
        'productUrl': value['productUrl'],
        'url': value['url'],
        'unitPrice': value['unitPrice'],
        'color': value['color'],
        'size': value['size'],
        'productNumber': value['productNumber'],
        'ctmsItemId': value['ctmsItemId'],
        'sourceType': value['sourceType'],
    };
}

